import React, { useState } from 'react';
import InputField from '../ui/InputField';
import Button from '../ui/Button';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaInstagram, FaCamera, FaDove } from 'react-icons/fa';
import 'react-toastify/dist/ReactToastify.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter your email address.');
      return;
    }
    setLoading(true);
    try {
      // Simulate API call
      setTimeout(() => {
        toast.success('Thank you for subscribing!');
        setEmail('');
        setLoading(false);
      }, 1000);
    } catch (error) {
      toast.error('Failed to subscribe. Please try again later.');
      setLoading(false);
    }
  };

  return (
    <footer className="bg-black text-white pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-8">


        {/* Footer Links and Socials */}
        <div className="bg-black pt-8 pb-4">
          <div className="flex flex-col items-center gap-6">
            <div className="flex flex-wrap justify-center gap-8 mb-6">
              <Link to="/privacy-policy" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-[#d4af37] font-medium text-base transition-colors duration-200 hover:text-white">Privacy Policy</Link>
              <Link to="/general-terms/page/1" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-[#d4af37] font-medium text-base transition-colors duration-200 hover:text-white">Terms & Conditions</Link>
              <Link to="/shipping-info" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-[#d4af37] font-medium text-base transition-colors duration-200 hover:text-white">Shipping Info</Link>
              <Link to="/returns" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-[#d4af37] font-medium text-base transition-colors duration-200 hover:text-white">Returns</Link>
            </div>
            <div className="flex gap-6 mb-6">
              <a href="https://www.instagram.com/elixirhoneyofficial/" className="bg-[#d4af37] hover:bg-white text-white hover:text-[#d4af37] rounded-full w-10 h-10 flex items-center justify-center transition-colors duration-200">
                <FaInstagram size={20} />
              </a>
              <a href="#" className="bg-[#d4af37] hover:bg-white text-white hover:text-[#d4af37] rounded-full w-10 h-10 flex items-center justify-center transition-colors duration-200">
                <FaCamera size={20} />
              </a>
              <a href="#" className="bg-[#d4af37] hover:bg-white text-white hover:text-[#d4af37] rounded-full w-10 h-10 flex items-center justify-center transition-colors duration-200">
                <FaDove size={20} />
              </a>
            </div>
            <p className="text-center text-sm text-gray-400 mt-2">© 2024 Elixir. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
